<template>
  <v-card>
    <v-toolbar dark color="#0c88c2">
      <v-btn icon dark @click="toggleDialog">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Credit Note Details (ID: {{creditNoteInfo.id}})</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text float-left @click="newRegionDialog=true" v-if="edit">Add a new section</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-container v-for="(section, indexSection) in creditNoteInfo.sections" :key="indexSection">
      <v-row justify="space-between">
        <v-col md="10" sm="8" cols="7">
          <h2 class="raleway-bold">{{section.header}}</h2>
        </v-col>
        <v-col md="2" sm="4" cols="5">
          <v-btn fab dark color="blue" @click="openNewLineDialog(section, indexSection)" v-if="edit">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn v-if="edit" text color="red" @click="toggleDeleteSectionDialog(section, indexSection)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <template v-for="(info, index) in section.rows">
        <v-list three-line subheader>
          <v-list-item>
            <v-row align="center" :class="{'no-gutters': $vuetify.breakpoint.smAndDown}">
              <v-col cols="12" md="3">
                <v-list-item-content v-if="!(editedSection === indexSection && editedIndex === index)" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-divider></v-divider>
                  <v-list-item-title>
                    Date: {{info.date}}
                  </v-list-item-title>
                  <v-list-item-subitle class="py-2">
                      Description: {{info.description}}
                  </v-list-item-subitle>
                  <v-list-item-subtitle>
                    Unit of Measure: {{info.uom}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content v-else :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title>
                    Date: <input v-model="editedRow.date">
                  </v-list-item-title>
                  <v-list-item-subtitle class="py-2">
                    Description: <input v-model="editedRow.description">
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                        Unit of Measure:
                        <select :items="uoms" v-model="editedRow.uom">
                          <option v-for="(uom, index) in uoms" :key="index" :value="uom">{{uom}}</option>
                        </select>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item-content v-if="!(editedSection === indexSection && editedIndex === index)" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title>
                    Quantity: {{info.quantity}}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title class="text--primary">
                    Quantity: <input v-model="editedRow.quantity">
                  </v-list-item-title>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item-content v-if="!(editedSection === indexSection && editedIndex === index)" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title>Unit Price: {{info.unit_price}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title>
                    Unit Price: <input v-model="editedRow.unit_price">
                  </v-list-item-title>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item-content v-if="!(editedSection === indexSection && editedIndex === index)" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title class="font-weight-bold">Amount: {{info.amount}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                  <v-list-item-title class="font-weight-bold">
                    Amount: {{amount}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="2" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
              <v-list-item-action v-if="edit">
                <v-row align="center">
                  <v-col cols="12" class="text-center">
                    <v-speed-dial
                      small
                      direction="right"
                      transition="slide-y-reverse-transition"
                    >
                      <template v-slot:activator>
                        <v-btn
                          fab
                          small
                          dark
                          :color="(editedSection === indexSection && editedIndex === index) ? 'green' : '#00a7d3'"
                          @click="!(editedSection === indexSection && editedIndex === index) ? editLine(info, indexSection) : save()"
                        >
                          <v-icon v-if="!(editedSection === indexSection && editedIndex === index)">edit</v-icon>
                          <v-icon v-else>check</v-icon>
                        </v-btn>
                      </template>
                      <v-btn
                        @click="close()"
                        color="red"
                        fab
                        small
                        dark
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-speed-dial>
                  </v-col>
                  <v-col cols="12" class="text-center" v-if="edit">
                    <v-btn small text dark>
                      <v-icon color="red" @click="toggleDeleteDialog(index, indexSection)">delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-action>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </template>
    </v-container>

    <v-dialog
      v-model="alertDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          {{message}}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn @click="alertDialog=false" text color="blue darken-1">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog" v-if="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this line
          {{creditNoteInfo.sections[lineToBeDeleted[1]].rows[lineToBeDeleted[0]].id}} ? <br>
          This action cannot be reversed.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="red" @click="deleteDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteLine">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteSectionDialog" v-if="deleteSectionDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete the section
          {{sectionToBeDeleted.header}} and all the invoices of the
          section ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="red" @click="deleteSectionDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteSection">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newLineDialog" width="800px">
      <v-card>
        <v-card-title>
          <h2>Line Information</h2>
          <v-btn
            fab
            dark
            small
            @click="newLineDialog=false;"
            color="blue-grey lighten-2"
            class="ml-auto"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-row justify="space-around" align="center" class="py-4">
            <v-col cols="5">
             <h3>Invoice Number</h3>
            </v-col>
            <v-col cols="6">
              <h3>{{creditNoteInfo.id}}</h3>
            </v-col>
            <v-col cols="5">
             <h3>Description</h3>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="editedRow.description"></v-text-field>
            </v-col>
            <v-col cols="5">
             <h3>UOM</h3>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="editedRow.uom"
                :items="uoms">
              </v-select>
            </v-col>
            <v-col cols="5">
             <h3>Quantity</h3>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedRow.quantity"
                type="number"
                onkeydown="javascript: return event.keyCode == 69 ? false : true"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
             <h3>Unit Price</h3>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editedRow.unit_price"
                type="number"
                onkeydown="javascript: return event.keyCode == 69 ? false : true"
              ></v-text-field>
            </v-col>

            <v-col cols="5">
             <h3>Date</h3>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="menu1"
                v-model="menu1"
                close-on-content-click
                :nudge-bottom="100"
                transition="scale-transition"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    prepend-icon="event"
                    v-model="editedRow.date"
                    class="headline" readonly
                    @click.native="menu1 = true"></v-text-field>
                </template>
                <v-date-picker v-model="editedRow.date" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="5">
             <h3>Region</h3>
            </v-col>
            <v-col cols="6">
             <h3>{{regions[editedRow.region - 1].name}}</h3>
            </v-col>
            <v-col cols="5">
             <h3>Amount</h3>
            </v-col>
            <v-col cols="6">
             <h3>{{amount}}</h3>
              <!--<v-text-field v-model="editedRow.amount" class="headline"></v-text-field>-->
            </v-col>
            <v-row justify="center">
              <v-btn text @click="close" color="blue-grey lighten-2">Close</v-btn>
              <v-btn text @click="addNewLine" color="blue darken-1">Save</v-btn>
            </v-row>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="newRegionDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h3>Select the region to add</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="newRegionDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="newSection"
                :items="emptyRegions"
                label="Region"
                item-text="name"
                return-object
                @input="createNewSection"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
    import axios from 'axios'

    // @vuese
    // Credit note full screen displayer.
    // Allows you to manage every line of the credit notes (add, delete or edit...).
    // @group Invoices
    export default {
        name: "CreditNoteDisplayer",
        props: {
            // Toggles credit note dialog
            toggleDialog: Function,
            // Credit note Object to be edited and displayed
            creditNoteInfo: Object,
            edit: Boolean,
            regions: Array,
        },
        data() {
            return {
                fields: [
                    {text: 'Date', value: 'date',}
                ],
                newRegionDialog: false,
                newSection: null,
                menu1: false,
                fab: false,
                alertDialog: false,
                message: '',
                keyCard: 0,
                closeSwitch: false,
                deleteDialog: false,
                deleteSectionDialog: false,
                lineToBeDeleted: [],
                sectionToBeDeleted: null,
                newLineDialog: false,
                maskInvoiceNum: '####################',
                maskQuantity: '####',
                maskUnitPrice: '##.##',
                maskAmount: '######.##',
                editedIndex: -1,
                editedSection: -1,
                editedRow: {
                    id: null,
                    inv_number: null,
                    description: null,
                    uom: null,
                    quantity: null,
                    unit_price: null,
                    date: null,
                    region: 1,
                    zone: null,
                    amount: null,
                },
                defaultRow: {
                    id: null,
                    inv_number: null,
                    description: null,
                    uom: null,
                    quantity: null,
                    unit_price: null,
                    date: null,
                    region: 1,
                    zone: null,
                    amount: null,
                },
                newLineSectionIndex: null,
                uoms: ['Boxes', 'Deliveries', 'Dock Bookings', 'Hours', 'Line Haul', 'Non Advice', 'Pallets', 'PH Surcharge', 'Pick Ups',
                    'SMS Number', 'Surcharge'],
            }
        },
        methods: {
            // @vuese
            // Closes dialog
            closeDialog() {
                this.toggleDialog();
            },
            // @vuese
            // Adds a new line to an already existing section and POST it in the /invoices/{inv_number}/creditnotes/{creditnote_id}/lines endpoint
            addNewLine() {
                this.newLineDialog = false;
                this.editedRow.amount = this.amount;
                axios.post(process.env.API_URL + '/invoices/' + this.creditNoteInfo.inv_number + '/creditnotes/' + this.creditNoteInfo.id + '/lines', this.editedRow)
                    .then((response) => {
                        this.creditNoteInfo.sections[this.newLineSectionIndex].rows.unshift(response.data);
                        this.$store.commit('displaySnackbar', 'New line created');
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR' + response.response.data.error);
                    })
                // this.$vuetify.goTo(9999, {duration: 1000, offset: 1000});
            },
            // @vuese
            // Toggles editing mode (text-fields become editable) on an already existing credit note line
            // @arg Takes the credit note Object you want to edit and its sectionIndex
            editLine(item, sectionIndex) {
                // this.editedIndex = this.lineArray.indexOf(item);
                console.log(sectionIndex);
                this.editedIndex = this.creditNoteInfo.sections[sectionIndex].rows.indexOf(item);
                this.editedSection = sectionIndex;
                this.editedRow = Object.assign({}, item);
                this.editArray[this.editedIndex] = true;
            },
            // @vuese
            // Saves changes made on a credit note line and PUT them in /invoices/{inv_number}/creditnotes/{creditnote_id}/lines/{line_id}
            save() {
                if (this.editedIndex > -1) {
                    this.editedRow.quantity = parseFloat(this.editedRow.quantity);
                    this.editedRow.unit_price = parseFloat(this.editedRow.unit_price);
                    this.editedRow.amount = this.amount;
                    axios.put(process.env.API_URL + '/invoices/' + this.creditNoteInfo.inv_number
                        + '/creditnotes/' + this.creditNoteInfo.id
                        + '/lines/' + this.editedRow.id, this.editedRow)
                        .then((response) => {
                            Object.assign(this.creditNoteInfo.sections[this.editedSection].rows[this.editedIndex], response.data);
                            this.$store.commit('displaySnackbar', 'Credit note line edited.');

                            this.close();

                        })
                        .catch((response) => {
                            this.close();
                            this.$store.commit('displaySnackbar', 'ERROR' + response.response.data.error);
                        })

                } else {
                    this.close();

                }
            },
            // @vuese
            // Closes the edit mode of a credit note line and resets every relevant variable to default.
            close() {
                this.editArray[this.editedIndex] = false;
                this.editedRow = Object.assign({}, this.defaultRow);
                this.editedIndex = -1;
                this.editedSection = -1;
                this.newLineSectionIndex = null;
                this.newLineDialog = false;
            },
            // @vuese
            // Creates a new section (only front-end)
            createNewSection() {
                this.newRegionDialog = false;
                this.creditNoteInfo.sections.push(
                    {
                        header: this.newSection.name,
                        rows: [],
                        total: null,
                    }
                );
                this.newLineDialog = false;
                this.$store.commit('displaySnackbar', 'New section created: ' + this.newSection.name);
            },
            // @vuese
            // Stores the pointed item as lineToBeDeleted and toggles delete line dialog
            // @arg Takes the index of the lineToBeDeleted in the entire creditnotes list and the section index as arguments.
            toggleDeleteDialog(index, indexSection) {
                this.lineToBeDeleted = [index, indexSection];
                this.deleteDialog = true;
            },
            // @vuese
            // Stores the pointed section as sectionToBeDeleted and toggles delete section dialog.
            // @arg Takes the section Object and the section index as arguments.
            toggleDeleteSectionDialog(section, indexSection) {
                this.sectionToBeDeleted = [section, indexSection];
                this.deleteSectionDialog = true;
            },
            // @vuese
            // Deletes lineToBeDeleted credit note line
            deleteLine() {
                this.deleteDialog = false;
                // this.message = 'You deleted the line ' + 'successfully !';
                // this.alertDialog = true;

                axios.delete(process.env.API_URL + '/invoices/' + this.creditNoteInfo.inv_number
                    + '/creditnotes/' + this.creditNoteInfo.id
                    + '/lines/' + this.creditNoteInfo.sections[this.lineToBeDeleted[1]].rows[this.lineToBeDeleted[0]].id)
                    .then((response) => {
                        this.creditNoteInfo.sections[this.lineToBeDeleted[1]].rows.splice(this.lineToBeDeleted[0], 1);
                        this.$store.commit('displaySnackbar', 'Credit note line deleted');
                        this.lineToBeDeleted = [];
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR' + response.response.data.error);
                    })

            },
            // @vuese
            // Deletes sectionToBeDeleted section
            deleteSection() {
                this.deleteSectionDialog = false;
                // this.message = 'You deleted the section ' + 'successfully !';
                // this.alertDialog = true;

                this.$store.commit('displaySnackbar', 'You deleted the section "' + this.creditNoteInfo.sections[this.sectionToBeDeleted[1]].header
                    + '" successfully.');
                this.creditNoteInfo.sections.splice(this.sectionToBeDeleted[1], 1);
                this.lineToBeDeleted = [];
            },
            // @vuese
            // Opens new line dialog
            // @arg Takes section object and the section index as arguments.
            openNewLineDialog(section, indexSection) {
                console.log(section);
                // Reset to default values
                this.editedRow = this.defaultRow;
                this.newLineSectionIndex = indexSection;
                this.editedRow.region = this.regions.filter((region) => {
                    return region.name === section.header
                })[0].id;
                this.editedRow.id = this.creditNoteInfo.id;
                this.editedRow.date = this.creditNoteInfo.date;
                this.newLineDialog = true;
            },
        },
        computed: {
            // @vuese
            // Title of the 'New Item'/'Edit Item' Dialog
            dialogTitle() {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
            // @vuese
            // Array with true for the indexes of the lines that are being edited
            editArray() {
                let editArray = [];
                for (var j = 0; j < this.creditNoteInfo.sections.length; j++) {
                    for (var i = 0; i < this.creditNoteInfo.sections[j].rows.length; i++) {
                        editArray.push(false);
                    }
                }
                return editArray
            },
            // @vuese
            // Total amount for the edited row = quantity * unit_price
            amount() {
                return this.editedRow.quantity * this.editedRow.unit_price
            },
            // @vuese
            // Returns a list of Objects with all the regions that do not already have credit notes in them
            emptyRegions() {
                return this.regions.filter((elt) => {
                    return !this.creditNoteInfo.sections.map((section) => {
                        return section.header
                    }).includes(elt.name)
                })
            }
        }
    }
</script>

<style scoped>
  input {
    width: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/Invoices/CreditNoteDisplayer.vue